<script>
  import { BreadcrumbItem, Col,Breadcrumb } from 'sveltestrap'
  import Card from '../../Core/Card.svelte'
  import data from '../../../Data/BonusUi/BonusUi.json'
  import { ColoredBreadcrumb, ColoredBreadcrumbMessage, Home, href, Library } from '../../../utils/Constant/Constant';
</script>

<Col sm="12">
  <Card headerTitle={ColoredBreadcrumb} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{@html ColoredBreadcrumbMessage}</span>
    </div>
    <div slot="contentbody">
      <Breadcrumb class="breadcrumb-colored m-b-30 bg-primary">
        <BreadcrumbItem href="#">{Home}</BreadcrumbItem>
        <BreadcrumbItem active>{Library}</BreadcrumbItem>
      </Breadcrumb>
      {#each data.coloredBreadcrumbData as breadcrumbItem}
        <Breadcrumb class="breadcrumb-colored breadcrumb-colors {breadcrumbItem.class} bg-{breadcrumbItem.color}">
          <BreadcrumbItem href={href} class={breadcrumbItem.textcolor}>{Home}</BreadcrumbItem>
          <BreadcrumbItem active class={breadcrumbItem.textcolor}>{Library}</BreadcrumbItem>
        </Breadcrumb>
      {/each} 
    </div>
  </Card>
</Col>
